module.exports = __webpack_public_path__ + "img/3.9adf9de9.png";